const config = {
  environment: 'dev',
  redirect_url: 'http://localhost:4000/callback',
  api_url: 'http://localhost:5002',
  mock: false,
};

export default config;
